<template>
    <div>
        <b-form>
            <div class="row">
                <div class="col-12 col-sm-6">
                    <card-title-component :title="$t('ceremony.location.ceremony-title')"></card-title-component>
                    <div class="card-content">
                        <div class="row">
                            <div class="col">
                                <b-form-group label="">
                                    <b-form-radio-group id="radiosCeremony" v-model="localLocationTypeCeremony"
                                                        class="location-radio-group"
                                                        name="radioSubComponentCeremony">
                                        <b-form-radio value="church">{{$t('ceremony.location.church')}}</b-form-radio>
                                        <b-form-input id="church-text-input-ceremony"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localChurchTextCeremony"
                                                      required
                                                      :placeholder="$t('ceremony.location.locationPlaceholder')"
                                                      :disabled="localLocationTypeCeremony != 'church'">
                                        </b-form-input>
                                        <div class="gap"></div>
                                        <b-form-radio value="nature">{{$t('ceremony.location.nature')}}</b-form-radio>
                                        <b-form-input id="nature-text-input-ceremony"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localNatureTextCeremony"
                                                      required
                                                      :placeholder="$t('ceremony.location.locationPlaceholder')"
                                                      :disabled="localLocationTypeCeremony != 'nature'">
                                        </b-form-input>
                                        <div class="gap"></div>
                                        <b-form-radio value="restaurantClub">
                                            {{$t('ceremony.location.restaurantClub')}}
                                        </b-form-radio>
                                        <b-form-input id="club-text-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localRestaurantClubTextCeremony"
                                                      required
                                                      :placeholder="$t('ceremony.location.locationPlaceholder')"
                                                      :disabled="localLocationTypeCeremony != 'restaurantClub'">
                                        </b-form-input>
                                        <div class="gap"></div>
                                        <b-form-radio value="otherLocation">{{$t('ceremony.location.other')}}
                                        </b-form-radio>
                                        <b-form-input id="location-other-text-input-ceremony"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localLocationOtherTextCeremony"
                                                      required
                                                      :placeholder="$t('ceremony.location.locationPlaceholder')"
                                                      :disabled="localLocationTypeCeremony != 'otherLocation'">
                                        </b-form-input>
                                    </b-form-radio-group>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <card-title-component :title="$t('ceremony.location.observance-title')"></card-title-component>
                    <div class="card-content">
                        <div class="row">
                            <div class="col">
                                <b-form-group label="">
                                    <b-form-radio-group id="radiosObservance" v-model="localLocationTypeObservance"
                                                        class="location-radio-group"
                                                        name="radioSubComponentObservance">
                                        <b-form-radio value="church">{{$t('ceremony.location.church')}}</b-form-radio>
                                        <b-form-input id="church-text-input-observance"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localChurchTextObservance"
                                                      required
                                                      :placeholder="$t('ceremony.location.locationPlaceholder')"
                                                      :disabled="localLocationTypeObservance != 'church'">
                                        </b-form-input>
                                        <div class="gap"></div>
                                        <b-form-radio value="nature">{{$t('ceremony.location.nature')}}</b-form-radio>
                                        <b-form-input id="nature-text-input-observance"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localNatureTextObservance"
                                                      required
                                                      :placeholder="$t('ceremony.location.locationPlaceholder')"
                                                      :disabled="localLocationTypeObservance != 'nature'">
                                        </b-form-input>
                                        <div class="gap"></div>
                                        <b-form-radio value="restaurantClub">
                                            {{$t('ceremony.location.restaurantClub')}}
                                        </b-form-radio>
                                        <b-form-input id="club-text-input-observance"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localRestaurantClubTextObservance"
                                                      required
                                                      :placeholder="$t('ceremony.location.locationPlaceholder')"
                                                      :disabled="localLocationTypeObservance != 'restaurantClub'">
                                        </b-form-input>
                                        <div class="gap"></div>
                                        <b-form-radio value="otherLocation">{{$t('ceremony.location.other')}}
                                        </b-form-radio>
                                        <b-form-input id="location-other-text-input-observance"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localLocationOtherTextObservance"
                                                      required
                                                      :placeholder="$t('ceremony.location.locationPlaceholder')"
                                                      :disabled="localLocationTypeObservance != 'otherLocation'">
                                        </b-form-input>
                                    </b-form-radio-group>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-6">
                    <card-title-component :title="$t('ceremony.food.title')"></card-title-component>
                    <div class="card-content">
                        <div class="row">
                            <div class="col">
                                <b-form-group id="apero-form-group"
                                              class="o-label"
                                              :label="$t('ceremony.food.apero')"
                                              label-for="apero-input">
                                    <b-form-input id="apero-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localApero"
                                                  required
                                                  :placeholder="$t('ceremony.food.apero')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <b-form-group id="menu-form-group"
                                              class="o-label"
                                              :label="$t('ceremony.food.menu')"
                                              label-for="menu-input">
                                    <b-form-input id="menu-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localMenu"
                                                  required
                                                  :placeholder="$t('ceremony.food.menu')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <b-form-group id="beverages-form-group"
                                              class="o-label"
                                              :label="$t('ceremony.food.beverages')"
                                              label-for="beverages-input">
                                    <b-form-input id="beverages-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localBeverages"
                                                  required
                                                  :placeholder="$t('ceremony.food.beverages')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <b-form-group id="dishes-misc-form-group"
                                              class="o-label"
                                              :label="$t('ceremony.food.dishesMisc')"
                                              label-for="dishes-misc-input">
                                    <b-form-input id="dishes-misc-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localDishesMisc"
                                                  required
                                                  :placeholder="$t('ceremony.food.dishesMisc')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <card-title-component :title="$t('ceremony.decoration.title')"></card-title-component>
                    <div class="card-content">
                        <div class="row">
                            <div class="col">
                                <b-form-group id="ceremony-flowers-form-group"
                                              class="o-label"
                                              :label="$t('ceremony.decoration.ceremonyFlowers')"
                                              label-for="ceremony-flowers-input">
                                    <b-form-input id="ceremony-flowers-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localCeremonyFlowers"
                                                  required
                                                  :placeholder="$t('ceremony.decoration.ceremonyFlowers')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <b-form-group id="observance-flowers-form-group"
                                              class="o-label"
                                              :label="$t('ceremony.decoration.observanceFlowers')"
                                              label-for="observance-flowers-input">
                                    <b-form-input id="observance-flowers-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localObservanceFlowers"
                                                  required
                                                  :placeholder="$t('ceremony.decoration.observanceFlowers')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <b-form-group id="observance-decoration-form-group"
                                              class="o-label"
                                              :label="$t('ceremony.decoration.observanceDecoration')"
                                              label-for="observance-decoration-input">
                                    <b-form-input id="observance-decoration-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localObservanceDecoration"
                                                  required
                                                  :placeholder="$t('ceremony.decoration.observanceDecoration')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <b-form-group id="decoration-misc-form-group"
                                              class="o-label"
                                              :label="$t('ceremony.decoration.decorationMisc')"
                                              label-for="decoration-misc-input">
                                    <b-form-input id="decoration-misc-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localDecorationMisc"
                                                  required
                                                  :placeholder="$t('ceremony.decoration.decorationMisc')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-6">
                    <card-title-component :title="$t('ceremony.music.title')"></card-title-component>
                    <div class="card-content">
                        <div class="row">
                            <div class="col">
                                <musics-container-component></musics-container-component>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-form>
        <div class="row">
            <div class="col button-div">
                <b-button class="save-button o-button" v-on:click="save">
                    Speichern
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
    import CardTitleComponent from '../ui/card/CardTitleComponent'
    import MusicsContainerComponent from './music/MusicsContainerComponent'
    import {mapActions, mapGetters, mapMutations} from 'vuex'
    import {
        CEREMONY_ACTION_GET_CEREMONY,
        CEREMONY_ACTION_SAVE_CEREMONY,
        CEREMONY_GETTER,
        CEREMONY_MUTATION_SINGLE_ENTRY,
        CEREMONY_NAMESPACE
    } from '../../store/modules/ceremony-types'
    import i18n from '../../assets/i18n/lang'

    export default {
        name: 'Ceremony',
        metaInfo () { return {title: i18n.t('ceremony.meta')} },
        components: {
            'card-title-component': CardTitleComponent,
            'musics-container-component': MusicsContainerComponent
        },
        computed: {
            ...mapGetters(CEREMONY_NAMESPACE, {
                ceremony: CEREMONY_GETTER
            }),
            localLocationTypeCeremony: {
                get () { return this.ceremony.locationTypeCeremony },
                set (value) { this.updateCeremony({locationTypeCeremony: value}) }
            },
            localChurchTextCeremony: {
                get () { return this.ceremony.churchTextCeremony },
                set (value) { this.updateCeremony({churchTextCeremony: value}) }
            },
            localNatureTextCeremony: {
                get () { return this.ceremony.natureText },
                set (value) { this.updateCeremony({natureTextCeremony: value}) }
            },
            localRestaurantClubTextCeremony: {
                get () { return this.ceremony.restaurantClubTextCeremony },
                set (value) { this.updateCeremony({restaurantClubTextCeremony: value}) }
            },
            localLocationOtherTextCeremony: {
                get () { return this.ceremony.locationOtherTextCeremony },
                set (value) { this.updateCeremony({locationOtherTextCeremony: value}) }
            },

            localLocationTypeObservance: {
                get () { return this.ceremony.locationTypeObservance },
                set (value) { this.updateCeremony({locationTypeObservance: value}) }
            },
            localChurchTextObservance: {
                get () { return this.ceremony.churchTextObservance },
                set (value) { this.updateCeremony({churchTextObservance: value}) }
            },
            localNatureTextObservance: {
                get () { return this.ceremony.natureTextObservance },
                set (value) { this.updateCeremony({natureTextObservance: value}) }
            },
            localRestaurantClubTextObservance: {
                get () { return this.ceremony.restaurantClubTextObservance },
                set (value) { this.updateCeremony({restaurantClubTextObservance: value}) }
            },
            localLocationOtherTextObservance: {
                get () { return this.ceremony.locationOtherTextObservance },
                set (value) { this.updateCeremony({locationOtherTextObservance: value}) }
            },
            localApero: {
                get () { return this.ceremony.apero },
                set (value) { this.updateCeremony({apero: value}) }
            },
            localMenu: {
                get () { return this.ceremony.menu },
                set (value) { this.updateCeremony({menu: value}) }
            },
            localBeverages: {
                get () { return this.ceremony.beverages },
                set (value) { this.updateCeremony({beverages: value}) }
            },
            localDishesMisc: {
                get () { return this.ceremony.dishesMisc },
                set (value) { this.updateCeremony({dishesMisc: value}) }
            },
            localCeremonyFlowers: {
                get () { return this.ceremony.ceremonyFlowers },
                set (value) { this.updateCeremony({ceremonyFlowers: value}) }
            },
            localObservanceFlowers: {
                get () { return this.ceremony.observanceFlowers },
                set (value) { this.updateCeremony({observanceFlowers: value}) }
            },
            localObservanceDecoration: {
                get () { return this.ceremony.observanceDecoration },
                set (value) { this.updateCeremony({observanceDecoration: value}) }
            },
            localDecorationMisc: {
                get () { return this.ceremony.decorationMisc },
                set (value) { this.updateCeremony({decorationMisc: value}) }
            }
        },
        methods: {
            ...mapMutations(CEREMONY_NAMESPACE, {
                updateCeremony: CEREMONY_MUTATION_SINGLE_ENTRY
            }),
            ...mapActions(CEREMONY_NAMESPACE, {
                loadCeremony: CEREMONY_ACTION_GET_CEREMONY,
                saveCeremony: CEREMONY_ACTION_SAVE_CEREMONY
            }),
            save () {
                this.saveCeremony(this.ceremony)
            }
        },
        created () {
            this.loadCeremony()
        }
    }
</script>

<style lang="scss" scoped>
    .button-div {
        text-align: right;
    }

    .location-radio-group {
        text-align: left;
    }

    .gap {
        padding-bottom: 40px;
    }
</style>



// WEBPACK FOOTER //
// src/components/funeral/CeremonyComponent.vue